import React, { useEffect, useState } from "react";
import "./App.scss";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Main from "./containers/Main";
import ProjectPage from "./containers/ProjectPage/ProjectPage";

// Preview bridge (no-op on normal visits)
import { __applyCmsPreviewPatch, __onCmsPreviewUpdate, theme, seo } from "./portfolio";
import { applyTheme } from "./utils/applyTheme";
import { applySeo } from "./utils/applySeo";

function App() {
  // Any preview patch triggers a rerender so imported portfolio bindings are re-read.
  const [previewTick, setPreviewTick] = useState(0);

  useEffect(() => {
    // Apply CMS-driven theme tokens to CSS variables (runs on normal site load too).
    applyTheme(theme);
    applySeo(seo);
  }, [previewTick]);

  useEffect(() => {
    // Subscribe to portfolio updates (used only by CMS preview)
    const unsubscribe =
      typeof __onCmsPreviewUpdate === "function"
        ? __onCmsPreviewUpdate(() => setPreviewTick(t => t + 1))
        : null;

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isCmsPreview = params.has("cmsPreview");
    if (!isCmsPreview) return;

    const onMessage = event => {
      // Same-origin only (admin + site on same domain)
      if (event.origin !== window.location.origin) return;
      const data = event.data;
      if (!data || data.type !== "CMS_PREVIEW_PATCH") return;

      try {
        __applyCmsPreviewPatch(data.patch || {});
        setPreviewTick(t => t + 1);
      } catch (e) {
        // Preview should never break the site.
        console.warn("CMS preview patch failed:", e);
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <Router key={previewTick}>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route path="/project/:id" component={ProjectPage} />
      </Switch>
    </Router>
  );
}

export default App;
